import React, { Fragment, useEffect, useContext, FC, InputHTMLAttributes,useState } from "react";
//import WorkOrderGrid from "./wo_grid/WorkOrderGrid";
import WorkOrderDetails from "./wo_details/WorkOrderDetails";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../app/stores/workorderStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import UserAuthStore from "../../../app/stores/userauthStore";
import AllDetails from "./wo_details/AllDetails";
import { ButtonContent, Icon, Placeholder, Search, Grid } from "semantic-ui-react";
import oneOrderStore from "../../../app/stores/oneOrderStore";
import { IWorkorder } from "../../../../src/app/models/workorder";
import WorkOrderGrid from "./wo_grid/WorkOrderGrid";
import AllGrid from "./wo_grid/AllGrid";







interface IProps {}


 function getvalue(clear){
   return clear ? "" : (document.getElementById("input") as HTMLInputElement).value
  
  
}


const WorkOrderDashboard: React.FC<IProps> = props => {
  const workOrderStore = useContext(oneOrderStore);
  const userAuthStore = useContext(UserAuthStore);

  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  let CurrentModule = sessionStorage.getItem("module")
  
  useEffect(() => {
    userAuthStore.HydrateAuthState();
   }, [userAuthStore]);

  
    function searchJobs(){
      console.log(getvalue(false));
      //filter specific prefix for effective searching
      let prefixcheck = ((getvalue(false).toUpperCase().startsWith("HX") && getvalue(false).length < 5) || (getvalue(false).toUpperCase().startsWith("J") && getvalue(false).length < 4))
      console.log(prefixcheck);
      
      if(!prefixcheck && getvalue(false).length >= 3){
        workOrderStore.loadWorkOrders(CurrentModule!,sessionObj.Username,sessionObj.Client.Id,getvalue(false));
      }
      else{
        alert("Enter at least 3 characters!")
      }
    }
    
  
    if (workOrderStore.loadinginitial)
      return <LoadingComponent content={"Loading: " + CurrentModule} inverted={true} />;


      
      return(
        <Fragment>
               

          <br></br>
          <Grid>
          <Search 
          icon= "none"
          id="input"
          open={false}
          onBlur={searchJobs}
          type='text'
          size="mini"
          display="inline"
          placeholder="Search live jobs"
          />
          <Icon name="search"  size="large" color="grey" class="circular"/>
          </Grid>
          
          
          <br></br>
        
          <AllGrid workorders={workOrderStore.workorders} />
        <AllDetails/>
    </Fragment>)
        
  };

  

  
  
   
  
  
   
  
   
    
    
  
  
;




//   useEffect(() => {
//     workOrderStore.loadWorkOrders(CurrentModule!,sessionObj.Username,sessionObj.Client.Id);
//   }, [workOrderStore, CurrentModule]);

//   if (workOrderStore.loadinginitial)
//     return <LoadingComponent content={"Loading: " + CurrentModule} inverted={true} />;

//   return (
//     <Fragment>
//       <AllGrid workorders={workOrderStore.workorders} />
//       <AllDetails />
//     </Fragment>
//   );
// };

export default observer(WorkOrderDashboard);
